import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhoneEnabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone_enabled"}/>
}
